import C from "action-types";
import { createReducer } from "utils/reducer";

const patientImport = createReducer(
  {
    isFetching: false,
    accountNumberFailures: []
  },
  {
    [C.PATIENT.PATIENT_IMPORT_REQUEST]: () => ({
      isFetching: true,
      accountNumberFailures: []
    }),
    [C.PATIENT.PATIENT_IMPORT_SUCCESS]: () => ({
      isFetching: false,
      accountNumberFailures: []
    }),
    [C.PATIENT.PATIENT_IMPORT_FAILURE]: (_, { payload }) => ({
      isFetching: false,
      accountNumberFailures: payload
    })
  }
);

export default patientImport;
